<template>
  <div class="siteBox">
    <div class="siteHead">
      <i style="color:rgba(48, 191, 120, 1);font-size:16px;margin-right:10px" class="el-icon-warning"></i>
      <span>温馨提示：</span>
    </div>
    <div class="sub-head" style="font-size:13px">
      <p>添加的站点请跟添加追踪代码的站点保持一致，否则系统将无法识别站点对应的访客</p>
      <p>安装代码成功后则不能再修改站点url地址</p>
    </div>



     <!-- <span class="font-12">添加的站点请跟添加追踪代码的站点保持一致，否则系统将无法识别站点对应的访客</span> -->

    <div class="siteContent fx">
      <div class="itemList fx">
        <span>站点名称：</span>
        <el-input style="width:290px" maxlength="80" v-model="listQuery.siteName" placeholder="请输入网站或网页的名称"></el-input>
      </div>
      <div class="itemList fx">
        <span>网址地址：</span>
        <el-input style="width:290px" v-model="listQuery.mainUrl" placeholder="请输入含http://或https://的网址"></el-input>
      </div>
      <el-button style="height:36px" type="dialog-confirm" @click="saveOrUpdateSite" w80>确认添加</el-button>
    </div>
    <div class="siteBottom">
      <!-- <div class="siteBottom-content">
        <span>添加管理</span>
        <img src="@/assets/tips.svg">
        <span class="font-12">安装代码成功后则不能再修改站点url地址</span>
      </div> -->
      <el-table :data="tableData"  style="width: 100%" v-loading="loading" stripe>
        <el-table-column align="center" type="index" label="序列" width="80"></el-table-column>
        <el-table-column align="left" prop="inputUrl" label="站点/URL" width="180"></el-table-column>
        <el-table-column align="center" prop="siteName" label="站点名称"></el-table-column>
        <el-table-column align="center" prop="createDate" label="创建时间"></el-table-column>
        <el-table-column align="left" prop="status" label="安装状态(监测到流量)">
          <template slot-scope="scope">
            <span style="margin-left:-10px" :class="['status-a', scope.row.status==1?'success':'error']">{{scope.row.status==1?'已成功':'未成功'}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="追踪代码存档">
          <template slot-scope="scope">
            <span @click="clickCode(scope.row)" style="cursor: pointer;color: #5088FF;">{{'查看代码'}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="name" label="操作">
          <template slot-scope="scope">
            
            <el-button type="text" @click="clickEdit(scope.row)">修改站点名称</el-button>
            <el-button type="text" @click="clickDelete(scope.row)">删除</el-button>
            
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination greyblock">
        <el-pagination :page-size="listQuery.pageSize" :pageNum="listQuery.pageNum" background layout="total, sizes, prev, pager, next, jumper" :total="total" @current-change="handleCurrentChange" @size-change="handleSizeChange"></el-pagination>
      </div>
    </div>
    <!-- 修改站点名称 -->
    <el-dialog title="修改站点名称" custom-class="dialog-s" :visible.sync="dialogFormVisible" width="350px">
      <div class="fx">
        <span class="checkname">站点名称</span>
        <el-input v-model="EditsiteName" size="small" maxlength="80"></el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false" size="small" w88>取 消</el-button>
        <el-button type="primary"  @click="submit" size="small" w88>确 定</el-button>
      </div>
    </el-dialog>
    <!-- 查看代码 -->
    <el-dialog title="代码存档" :visible.sync="dialogCode" width="690px" :close-on-click-modal="false">
        <!-- <span class="close" @click="clickClose">X</span>
        <p class="title">代码存档</p> -->
        <p class="info" style="margin-top:12px">将这段追踪代码贴到您的网页/页面上,即可识别访客背后的企业,让您与客户更进一步！</p>
        <div class="codeContent" id="copyText" v-loading="loadingJs" style="margin-top:16px;color:#555555">
            {{content}}
        </div>
        <div style="padding-bottom:14px">
          <el-button type="primary" @click="clickCopy" plain class="no-bg">复制</el-button>
        </div>
      <!-- <span class="btn" @click="clickCopy"> 复制代码</span> -->
    </el-dialog>

    <!-- 删除站点弹框 -->
    <el-dialog title="提示" custom-class="dialog-s" :visible.sync="isDel" width="350px" :close-on-click-modal="false">
      <div style="text-align:center;padding-top:16px;padding-bottom:24px">
        <i style="font-size:50px;color:#E6A23C" class="el-icon-warning-outline"></i>
        <p style="font-size: 14px;font-weight: 400;color: #333333;line-height: 20px;margin-top:10px">确定删除此站点吗？</p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isDel = false" size="small" w88>取 消</el-button>
        <el-button type="primary"  @click="openOkk" size="small" w88>确 定</el-button>
      </div>

    </el-dialog>


      <setDrawer ref="setDrawer" />
  </div>
</template>

<script>
import setDrawer from '../components/setDrawer'
import { saveOrUpdateSite, siteSelectListPage, deleteSiteId, queryAnonymousJS } from '../api/newClueApi'
export default {
  components: {
    setDrawer
  },
  data () {
    return {
      isDel:false,
      delId: null,
      listQuery: {
        siteName: '',
        mainUrl: '',
        pageNum: 1,
        pageSize: 10
      },
      tableData: [],
      loading: false,
      dialogFormVisible: false,
      EditsiteName: '',
      content: '',
      dialogCode: false,
      total: 0,
      loadingJs: false
    }
  },
  methods: {
    queryAnonymousJS (item) {
      this.loadingJs = true
      queryAnonymousJS({id:item.id}).then(res => {
        this.content = res.data.content
        this.loadingJs = false
      }).catch(()=>{
        this.loadingJs = false
      })
    },
    handleCurrentChange (val) {
      this.listQuery.pageNum = val
      this.siteSelectList()
    },
    handleSizeChange(val) {
      this.listQuery.pageNum = 1
      this.listQuery.pageSize = val
      this.siteSelectList()
    },
    clickClose () {
      this.dialogCode = false
    },
    clickCode (item) {
      this.dialogCode = true
      this.queryAnonymousJS(item)
    },
    clickCopy () {
      var strs0 = document.getElementById('copyText').innerText
      var textBox = document.createElement('input')
      textBox.value = strs0
      document.body.appendChild(textBox)
      textBox.select()
      document.execCommand('Copy')
      textBox.className = 'textBox'
      textBox.style.display = 'none'
      this.$message.success('复制成功')
    },
    saveOrUpdateSite () {
      if (!this.listQuery.siteName) {
        this.$message.error('请输入站点名称')
        return
      }
      if (!this.listQuery.mainUrl) {
        this.$message.error('请输入站点地址')
        return
      }
      var reg = '^((https|http|ftp|rtsp|mms)?://)'
      var re = new RegExp(reg)
      if (!re.test(this.listQuery.mainUrl)) {
        this.$message.error('请输入含http://或https://的网址')
        return
      }
      saveOrUpdateSite(this.listQuery).then(res => {
        this.$message.success('添加成功')
        this.siteSelectList()
        this.listQuery = {}
      })
    },
    siteSelectList () {
      this.loading = true
      siteSelectListPage(this.listQuery).then(res => {
        this.tableData = res.data.content
        this.total = res.data.totalElements
        this.loading = false
      })
    },
    clickDelete (item) {
      this.open(item)
    },
    open (item) {
      this.delId = item.id
      this.isDel = true

      // this.$confirm('确定删除此站点吗？', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // }).then(() => {
      //   deleteSiteId({ id: item.id }).then(res => {
      //     this.$message.success('删除成功')
      //     this.siteSelectList()
      //   }).catch(res => {
      //     this.$message.error(res.message)
      //   })
      // }).catch(() => {
      //   this.$message({
      //     type: 'info',
      //     message: '已取消删除'
      //   })          
      // })
    },
    openOkk() {
        deleteSiteId({ id: this.delId }).then(res => {
          this.$message.success('删除成功')
          this.siteSelectList()
          this.isDel = false
        }).catch(res => {
          this.$message.error(res.message)
        })
    },
    clickEdit (item) {
      this.EditsiteName = item.siteName
      this.dialogFormVisible = true
      this.listQuery.id = item.id
    },
    submit () {
      var data = {
        id: this.listQuery.id,
        siteName: this.EditsiteName,
        mainUrl: this.listQuery.mainUrl
      }
      saveOrUpdateSite(data).then(res => {
        this.$message.success('编辑成功')
        this.dialogFormVisible = false
        this.siteSelectList()
      })
    }
  },
  mounted () {
    this.siteSelectList()

    try {
      document.getElementsByClassName('pageWrap')[0].style.marginTop = '-8px'
    } catch (error) {
      
    }

  },
  beforeDestroy() {
        try {
      document.getElementsByClassName('pageWrap')[0].style.marginTop = 'auto'
    } catch (error) {
      
    }
  }

}
</script>

<style lang="scss" scoped>

.pagination{
  text-align: right;
    // background-color: #fff;
    border-radius: 0 0 4px 4px;
    padding: 16px;
    padding-right: 0;
//    /deep/ .el-pagination.is-background .el-pager li {
//     background-color: #fff;
//     border: 1px solid #dcdfe6;
//    }
//    /deep/  .el-pagination.is-background .btn-next{
//     background-color: #fff;
//     border: 1px solid #dcdfe6;
//   }
//   /deep/ .el-pagination.is-background .btn-prev {
//    background-color: #fff;
//     border: 1px solid #dcdfe6;
//   }
//   /deep/.is-background .el-pager li:not(.disabled).active {
//     background-color: #409eff;
//     border: 1px solid #409eff;
// }
}
// /deep/ .el-table{
//   border-top: 1px solid #EBEEF5;
// }
// /deep/ .el-table th:not(:last-child){
//    border-right: 1px solid #EBEEF5;
// }
// /deep/.el-table td:not(:last-child){
//    border-right: 1px solid #EBEEF5;
// }

.close{
  position: absolute;
    right: 20px;
    top: 20px;
    display: block;
    width: 25px;
    height: 25px;
    text-align: center;
    line-height: 25px;
    cursor: pointer;
    font-size: 16px;
}
.title{
  font-size: 16px;
  font-weight: 500;
  color: #000;
}
.info{
  font-size: 14px;
  font-weight: 400;
  color: #666666;
  line-height: 20px;
}
.success{
  color: #409EFF;
}
.codeContent{
  font-size: 13px;
  padding: 20px;
  background: RGBA(244, 245, 247, 1);
  border-radius: 8px;
    margin: 20px 0px;
    min-height: 88px;
    white-space: pre-line;
}
.error{
  color: red;
}
.checkname {
  width: 100px;
  line-height: 32px;
}
.siteHead {
  height: 42px;
  background: linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%);
  border-radius: 4px;
  // opacity: 0.8;
  display: flex;
  align-items: center;
  padding-left: 10px;
  > span {
    font-size: 13px;
    color: rgba(38, 38, 38, 1);
  }
  img {
    margin: 0 8px;
  }
}
.siteContent {
  // background: #fff;
  padding: 15px 20px;
  padding-left: 0;
  border-radius: 5px;
  // justify-content: space-between;
  .itemList {
    margin-right: 16px;
    // width: 40%;
    > span {
      // width: 100px;
      // padding-right: 8px;
      font-size: 14px;
      color: #333;
      line-height: 36px;
    }
  }
}
.mt-10 {
  margin-bottom: 10px;
}
.siteBottom {
  padding-bottom: 30px;
  // background: #fff;
  .siteBottom-content {
    background: #fff;
    border-radius: 5px 5px 0px 0px;
    padding: 10px 20px;
    > span {
      font-size: 16px;
      color: #333;
    }
    img {
      margin: 0 8px;
    }
  }
}
.font-12 {
  font-size: 12px !important;
}
/deep/ .el-dialog__header {
  // display: none;
}
/deep/ .el-dialog__body {
  // padding: 40px 20px;
  // position: relative;
}
/deep/.el-dialog__footer {
  // border-top: none;
  // padding-top: 0px;
}
/deep/ .el-table thead th .cell{
  font-size: 14px;
}
.btn {
    display: inline-block;
    width: 68px;
    height: 28px;
    text-align: center;
    line-height: 28px;
    border: 1px solid #3987ea;
    color: #3987ea;
    border-radius: 3px;
    cursor: pointer;
  }
  .sub-head{
    font-size: 13px;
    font-weight: 400;
    color: #8C8C8C;
    line-height: 18px;
    padding-left: 36px;
  }
  .status-a{
    display: flex;
    align-items: center;
    color: #343951;
  }
  .status-a::before{
    content: ' ';
    display: block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    margin-right: 4px;
    background: #E8E8F0;
  }
  .status-a.success::before{
    background: #30BF78;
  }
  /deep/ {
    .el-button--mini{
      height: 36px;
    }
  }
  .no-bg{
            width: 52px;
        height: 32px;
        line-height: 32px;
            line-height: 32px;
    text-align: center;
    padding: 0;
    background: none;
    /deep/ {
      .el-button--primary.is-plain{
        background: #ffffff;
        background: rgba(255,255,255,0.2000);
        box-shadow: 0px 2px 4px 0px rgba(80,136,255,0.1500);
        border-radius: 4px;
        border: 1px solid #5088FF;

      }
    }
  }

  /deep/ .el-table .el-table__cell{
    padding: 12px 0;
  }
</style>